module.exports = __webpack_public_path__ + "img/G.4661d382.jpg";